<template>
  <div class="pay-success">
    <van-circle v-model="currentRate" :rate="100" :speed="100" color="#01C15F">
      <div class="success">
        <van-icon name="success" color="#01C15F" size="40px" />
      </div>
    </van-circle>
    <div style="color: #01c15f;margin: 20px 0;">支付成功</div>
    <van-button @click="toIndex">订单列表</van-button>
    <van-button style="margin-top:15px;" @click="toContinue">返回首页</van-button>
  </div>
</template>

<script>
export default {
  name: "pay-success",
  data() {
    return {
      currentRate: 100,
    };
  },
  methods: {
    toIndex() {
      // this.$router.push({
      //   path: "/order",
      // });
      var locationUrl = window.location.href;
      var splitText = locationUrl.split('?')[1]
      var pathName = window.location.pathname;
      var pos = locationUrl.indexOf(pathName);
      var temp = locationUrl.substring(0, pos);
      var result = temp + '/shop/order?' + splitText;
      let mchData = {
        action: 'jumpOut',
        jumpOutUrl: result //跳转的页面
        // jumpOutUrl: 'https://m.uat.ganyoutong.cn/shop/order?shareId=1435781711673810946&tenantId=194861164269637' //跳转的页面
      }
      parent.postMessage(JSON.stringify(mchData), 'https://payapp.weixin.qq.com')
      // if(this.$route.query.type){
      //     this.$router.push({
      //         path: '/goods-order-list'
      //     })
      // }else {
      //     this.$router.push({
      //         path: '/self/order-manage'
      //     })
      // }
    },
    toContinue() {
      // this.$router.replace({ path: "/index" });
      var locationUrl = window.location.href;
      var splitText = locationUrl.split('?')[1]
      var pathName = window.location.pathname;
      var pos = locationUrl.indexOf(pathName);
      var temp = locationUrl.substring(0, pos);
      var result = temp + '/shop/index?' + splitText;
      let mchData = {
        action: 'jumpOut',
        jumpOutUrl: result //跳转的页面
        // jumpOutUrl: 'https://m.uat.ganyoutong.cn/shop/index?shareId=1435781711673810946&tenantId=194861164269637' //跳转的页面
      }
      parent.postMessage(JSON.stringify(mchData), 'https://payapp.weixin.qq.com')
    },
  },
};
</script>

<style lang="scss" scoped>
.success {
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay-success {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 40px;
}
</style>
